var map = {
	"./3-line-16x12px.svg": 662,
	"./Ellipse 35.svg": 663,
	"./Vector 12.svg": 664,
	"./Vector-1.svg": 665,
	"./Vector.svg": 666,
	"./activity-14x12-pink.svg": 667,
	"./activity-14x12.svg": 668,
	"./activity-grey-16px.svg": 669,
	"./activity-pink-16px.svg": 670,
	"./alert.svg": 671,
	"./approved-artwork-logo.svg": 672,
	"./arrow-left.svg": 673,
	"./article-grey.svg": 674,
	"./article-pink.svg": 675,
	"./artwork-grey.svg": 676,
	"./artwork.png": 58,
	"./avatar.png": 67,
	"./big-pink-logo-nopadding.png": 677,
	"./big-pink-logo.png": 164,
	"./big-white-logo-nopadding.png": 678,
	"./black-close-feature.png": 127,
	"./black-expand-feature.png": 165,
	"./black-logo-27.png": 269,
	"./black-logo-36.png": 270,
	"./black-logo-with-word.svg": 271,
	"./black-media-buttons.png": 679,
	"./black-word-logo.png": 680,
	"./change-password.svg": 681,
	"./chat-17x12.svg": 682,
	"./chat-18x12-grey.svg": 683,
	"./chat-dark-18x14.svg": 684,
	"./chat-darkgrey.svg": 685,
	"./chat-pink.svg": 686,
	"./chat.png": 687,
	"./close-12px-pink.svg": 688,
	"./close-30px-3f3e3c.svg": 689,
	"./close-30px-828282.svg": 690,
	"./close-30px-ec0f69.svg": 691,
	"./close-30px-ffffff.svg": 692,
	"./close-30px-pink.svg": 693,
	"./close-grey.svg": 694,
	"./close-white.svg": 695,
	"./collapse-828282.svg": 696,
	"./collectives-fcfafl.svg": 697,
	"./comment-grey.svg": 698,
	"./comment-pink.svg": 699,
	"./continue-saved-article-pink.svg": 700,
	"./continue-saved-article.svg": 701,
	"./copyurl-black.svg": 702,
	"./copyurl-grey.svg": 703,
	"./copyurl-hover.svg": 704,
	"./dark-gery-arrow-left.svg": 705,
	"./dark-grey-close.png": 272,
	"./dustbin-grey-16px.svg": 706,
	"./dustbin-off.svg": 707,
	"./dustbin-on.svg": 708,
	"./dustbin-pink-16px.svg": 709,
	"./editor-toolbar-icon-bold.svg": 710,
	"./editor-toolbar-icon-italic.svg": 711,
	"./editor-toolbar-icon-underline.svg": 712,
	"./efefef-dustbin-18px.svg": 713,
	"./efefef-pencil-18px.svg": 714,
	"./email.svg": 715,
	"./embed-video.svg": 716,
	"./envelope-line.svg": 717,
	"./envelope.svg": 718,
	"./exclamation-triangle.png": 273,
	"./expand-collapse-grey-16px.svg": 719,
	"./expand-collapse-grey.svg": 720,
	"./expand-collapse-pink-16px.svg": 721,
	"./expand-collapse-pink.svg": 722,
	"./eye-password-see.svg": 723,
	"./eye-password.svg": 724,
	"./eye-pink.svg": 725,
	"./fa-40-3f3e3c.svg": 726,
	"./fa-40px-3f3e3c.svg": 727,
	"./fa-icon-162.png": 728,
	"./fa-icon-28-dark.svg": 729,
	"./fa-icon-28-light.svg": 730,
	"./fa-icon-28-pink.svg": 731,
	"./fa-icon-32-dark.svg": 732,
	"./fa-icon-32-grey.svg": 733,
	"./fa-icon-32-light.svg": 734,
	"./fa-icon-32-pink.svg": 735,
	"./fa-icon-32.png": 736,
	"./fa-icon-32.svg": 737,
	"./fa-icon-44-pink.png": 738,
	"./fa-icon-44-white.png": 739,
	"./fa-icon-50-light.svg": 740,
	"./fa-icon-50-pink.svg": 741,
	"./fa-icon.png": 174,
	"./facebook-black.svg": 742,
	"./facebook-grey.svg": 743,
	"./facebook-hover.svg": 744,
	"./fb-black.svg": 745,
	"./fb-pink.svg": 746,
	"./fc-40-3f3e3c.svg": 747,
	"./fc-40px-3f3e3c.svg": 748,
	"./fc-icon-28-dark.svg": 749,
	"./fc-icon-28-light.svg": 750,
	"./fc-icon-28-pink.svg": 751,
	"./fc-icon-32-dark.svg": 752,
	"./fc-icon-32-grey.svg": 753,
	"./fc-icon-32-light.svg": 754,
	"./fc-icon-32-pink.svg": 755,
	"./fc-icon-32.svg": 756,
	"./fc-icon-44-pink.png": 757,
	"./fc-icon-44-white.png": 758,
	"./fc-icon-50-light.svg": 759,
	"./fc-icon-50-pink.svg": 760,
	"./fc-icon.png": 175,
	"./fcfafl.svg": 761,
	"./featured-grey.svg": 762,
	"./featured-pink.svg": 763,
	"./fl-40-3f3e3c.svg": 764,
	"./fl-40px-3f3e3c.svg": 765,
	"./fl-icon-28-dark.svg": 766,
	"./fl-icon-28-light.svg": 767,
	"./fl-icon-28-pink.svg": 768,
	"./fl-icon-32-dark.svg": 769,
	"./fl-icon-32-grey.svg": 770,
	"./fl-icon-32-light.svg": 771,
	"./fl-icon-32-pink.svg": 772,
	"./fl-icon-32.svg": 773,
	"./fl-icon-44-pink.png": 774,
	"./fl-icon-44-white.png": 775,
	"./fl-icon-50-light.svg": 776,
	"./fl-icon-50-pink.svg": 777,
	"./fl-icon.png": 201,
	"./flag-33x40px.svg": 778,
	"./flag-confirm-icon.svg": 779,
	"./flag-grey.svg": 780,
	"./flag-outline.svg": 781,
	"./flag-pink.svg": 782,
	"./follow-dark-18x14.svg": 783,
	"./follow-dark-grey.svg": 784,
	"./follow-light-grey.svg": 785,
	"./follow-pink.svg": 786,
	"./follow.png": 787,
	"./following-pink.svg": 788,
	"./footer-logo-with-name.svg": 789,
	"./footer-logo.png": 274,
	"./format-type-form-header.svg": 790,
	"./fullscreen-grey-14px.svg": 791,
	"./fullscreen-grey-16px.svg": 792,
	"./fullscreen-pink-14px.svg": 793,
	"./fullscreen-pink-16px.svg": 794,
	"./gallery-icon-hover.svg": 795,
	"./gallery-icon.svg": 796,
	"./gallery.svg": 797,
	"./grey-arrow-left.svg": 798,
	"./grey-arrow-right.svg": 799,
	"./grey-bell.png": 800,
	"./grey-close-feature.png": 128,
	"./grey-close.png": 141,
	"./grey-close.svg": 801,
	"./grey-expand-collapse.svg": 802,
	"./grey-expand-feature.png": 166,
	"./grey-home.png": 803,
	"./grey-left-arrow.png": 804,
	"./grey-logo-23.png": 275,
	"./grey-right-arrow.png": 805,
	"./grey-scroll-top.svg": 806,
	"./grey-search.png": 276,
	"./grey-tick.svg": 807,
	"./grey-zine-down-arrow.png": 808,
	"./grey-zine-up-arrow.png": 809,
	"./grey828282-close.png": 277,
	"./icon-pending.svg": 810,
	"./image.svg": 811,
	"./itch-icon-21-pink.svg": 812,
	"./itch-icon-36.svg": 813,
	"./itch-logo-black.svg": 814,
	"./itch.png": 815,
	"./itch.svg": 278,
	"./itch@2x.png": 816,
	"./itch@4x.png": 817,
	"./itch_white.png": 818,
	"./itch_white.svg": 167,
	"./itch_white@2x.png": 819,
	"./itch_white@4x.png": 820,
	"./itchbook-grey-14px.svg": 821,
	"./itchbook-grey-16px.svg": 822,
	"./itchbook-grey.svg": 823,
	"./itchbook-pink-14px.svg": 824,
	"./itchbook-pink-16px.svg": 825,
	"./itchbook-pink.svg": 826,
	"./lightgrey-close.svg": 827,
	"./line-arrow-right-black.svg": 828,
	"./line-arrow-right-pink.svg": 829,
	"./link.svg": 830,
	"./location-12px-dark.svg": 831,
	"./location-efefef-18px.svg": 832,
	"./location-pink.svg": 833,
	"./location-size=8px-colour-efefef.svg": 834,
	"./location-white.svg": 835,
	"./location.png": 836,
	"./logo-111px-ec0f69.svg": 837,
	"./logo-18px-efefef.svg": 838,
	"./logo-24px-efefef.svg": 839,
	"./logo-26px-2b2a29.svg": 840,
	"./logo-27px-ec0f69.svg": 841,
	"./logo-4x.png": 842,
	"./logo-desktop-nav-2b2a29.svg": 843,
	"./logo-desktop-nav-ec0f69.svg": 844,
	"./logo-desktop-nav-efefef.svg": 845,
	"./logo-ec0f69.svg": 846,
	"./logo-mobile-nav-2b2a29.svg": 847,
	"./logo-mobile-nav-ec0f69.svg": 848,
	"./logo-mobile-nav-efefef.svg": 849,
	"./logo-size-111px-colour=ec0f69.svg": 850,
	"./logo-size-18px-colour-light-efefef.svg": 851,
	"./m-right-arrow.png": 852,
	"./media-buttons-sprites.png": 853,
	"./media-buttons-sprites2.png": 854,
	"./music-off-hover.png": 855,
	"./music-off.png": 856,
	"./music-on-hover.png": 857,
	"./music-on.png": 858,
	"./muted.svg": 859,
	"./new-article-bottom-pink.svg": 860,
	"./new-article-bottom.svg": 861,
	"./new-article-pink.svg": 862,
	"./new-article-top-pink.svg": 863,
	"./new-article-top.svg": 864,
	"./new-article.svg": 865,
	"./off.svg": 866,
	"./on.svg": 867,
	"./pencil-828282.svg": 868,
	"./pencil-efefef.svg": 869,
	"./pencil-grey-16px.svg": 870,
	"./pencil-pink-16px.svg": 871,
	"./pencil-pink.svg": 872,
	"./pending-6px.svg": 873,
	"./pin-8x10px-bdbdbd.svg": 874,
	"./pin-8x10px-pink.svg": 875,
	"./pink-alert-trash-triangle.svg": 876,
	"./pink-arrow-left.svg": 877,
	"./pink-arrow-right.svg": 878,
	"./pink-chat.svg": 879,
	"./pink-close.png": 168,
	"./pink-delete.svg": 880,
	"./pink-down-arrow.svg": 881,
	"./pink-dustbin-18px.svg": 882,
	"./pink-expand-collapse.svg": 883,
	"./pink-follow.svg": 884,
	"./pink-following.svg": 885,
	"./pink-left-arrow.png": 886,
	"./pink-logo-23.png": 202,
	"./pink-logo-24.png": 55,
	"./pink-logo-27.png": 279,
	"./pink-logo-36.png": 280,
	"./pink-logo-48.png": 281,
	"./pink-logo-80.png": 282,
	"./pink-logo-with-word.svg": 283,
	"./pink-media-buttons.png": 887,
	"./pink-pencil-14.svg": 888,
	"./pink-pencil-18px.svg": 889,
	"./pink-right-arrow.png": 890,
	"./pink-show.png": 891,
	"./pink-slash.svg": 892,
	"./pink-tick.svg": 893,
	"./pink-trashcan.svg": 894,
	"./pink-triangle.svg": 895,
	"./pink-unfollow.svg": 896,
	"./pinterest-black.svg": 897,
	"./pinterest-grey.svg": 898,
	"./pinterest-hover.svg": 899,
	"./pinterest-pink.svg": 900,
	"./plus-18x12-grey.svg": 901,
	"./plus-3f3e3c.svg": 902,
	"./rejected-22px.svg": 903,
	"./rejected.svg": 904,
	"./reveal-article-grey.svg": 905,
	"./reveal-article-pink.svg": 906,
	"./reveal-conversation-grey.svg": 907,
	"./reveal-conversation-pink.svg": 908,
	"./save-chat size-10px.svg": 909,
	"./search.svg": 910,
	"./share-fb-hover.svg": 911,
	"./share-fb.svg": 912,
	"./share-grey-14px.svg": 913,
	"./share-grey-16px.svg": 914,
	"./share-pin-hover.svg": 915,
	"./share-pin.svg": 916,
	"./share-pink-14px.svg": 917,
	"./share-pink-16px.svg": 918,
	"./share-tw-hover.svg": 919,
	"./share-tw.svg": 920,
	"./share-url-hover.svg": 921,
	"./share-url.svg": 922,
	"./shuffle-colour.svg": 923,
	"./shuffle-white.svg": 924,
	"./small_logo.png": 925,
	"./sprites.png": 926,
	"./sprites2.png": 927,
	"./sprites3.png": 928,
	"./sprites4.png": 929,
	"./stub-black.png": 930,
	"./stub-pink.png": 931,
	"./stub-white.png": 932,
	"./stub.png": 933,
	"./trending.png": 169,
	"./triangle.svg": 934,
	"./twitter-black.svg": 935,
	"./unfollow.svg": 936,
	"./unsubscribe.svg": 937,
	"./upload-image.svg": 938,
	"./url-black.svg": 939,
	"./url-pink.svg": 940,
	"./video.svg": 941,
	"./views-grey.svg": 942,
	"./views-pink.svg": 943,
	"./white-bell.png": 944,
	"./white-chat.svg": 945,
	"./white-close-feature.png": 129,
	"./white-close.png": 284,
	"./white-delete.svg": 946,
	"./white-edit.svg": 947,
	"./white-expand-feature.png": 170,
	"./white-follow.svg": 948,
	"./white-home.png": 949,
	"./white-left-arrow.png": 950,
	"./white-logo-23.png": 285,
	"./white-logo-27.png": 286,
	"./white-logo-36.png": 287,
	"./white-logo-with-word.svg": 288,
	"./white-media-buttons.png": 951,
	"./white-play-10px-over.svg": 952,
	"./white-play-10px.svg": 953,
	"./white-play.svg": 954,
	"./white-right-arrow.png": 955,
	"./white-search.png": 289,
	"./white-show.png": 956,
	"./white-tick.svg": 957,
	"./white-word-logo.png": 958,
	"./white-zine-down-arrow.png": 959,
	"./white-zine-up-arrow.png": 960,
	"./white-zine.png": 961,
	"./wow-grey-px14.svg": 962,
	"./wow-grey-px16.svg": 963,
	"./wow-grey.svg": 964,
	"./wow-pink-14px.svg": 965,
	"./wow-pink-16px.svg": 966,
	"./wow-pink.svg": 967,
	"./x-black.svg": 968,
	"./x-grey.svg": 969,
	"./x-hover.svg": 970,
	"./x-pink.svg": 971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 661;